/* Outdoer mobile header — JS-forced placement.
   CSS overrides kept getting beaten by something on this theme.
   Inline style with !important wins. Period. */
(function () {
  'use strict';

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  // Replace search-button with a plain <a> anchor. Always — even on re-runs.
  // Also force-close any open search modal that might be blocking taps.
  function wireSearchButton() {
    if (!isMobile()) return;
    console.log('[outdoer] wireSearchButton running');

    // CRITICAL: close any open search modal that might be intercepting taps
    var stuckModal = document.querySelector('#search-modal dialog[open]');
    if (stuckModal) {
      try { stuckModal.close(); } catch (e) {}
      stuckModal.removeAttribute('open');
      console.log('[outdoer] closed stuck-open search modal');
    }
    var modalWrapper = document.querySelector('#search-modal');
    if (modalWrapper) {
      modalWrapper.style.removeProperty('position');
      modalWrapper.style.removeProperty('top');
      modalWrapper.style.removeProperty('z-index');
    }

    // Find search-button — try multiple selectors
    var sb = document.querySelector('search-button') ||
             document.querySelector('.search-action') ||
             document.querySelector('button.search-modal__button')?.closest('search-button, .search-action');
    if (!sb) {
      console.log('[outdoer] no search-button found to replace');
      return;
    }
    // Skip if we already replaced it with our anchor
    if (sb.tagName === 'A' && sb.classList.contains('outdoer-search-link')) {
      console.log('[outdoer] already replaced');
      return;
    }
    console.log('[outdoer] replacing search-button:', sb.tagName, sb.className);

    var iconHTML = sb.innerHTML;
    var iconMatch = iconHTML.match(/<svg[\s\S]*?<\/svg>/i);
    var iconSVG = iconMatch ? iconMatch[0] : '<span style="font-size:20px;">&#x1F50D;</span>';

    var a = document.createElement('a');
    a.href = '/search';
    a.setAttribute('aria-label', 'Search');
    a.className = 'search-action header-actions__action outdoer-search-link';
    a.style.cssText = [
      'display:inline-flex',
      'align-items:center',
      'justify-content:center',
      'width:44px',
      'height:44px',
      'cursor:pointer',
      'text-decoration:none',
      'color:inherit',
      'grid-area:rightA',
      'margin-inline-end:24px',
      'justify-self:start',
      'position:relative',
      'z-index:10',
      'pointer-events:auto',
    ].join(' !important;') + ' !important;';
    a.innerHTML = iconSVG;
    // Make the inner SVG non-interactive so taps fall through to the anchor
    sb.replaceWith(a);
    var innerSvg = a.querySelector('svg, .svg-wrapper');
    if (innerSvg) innerSvg.style.pointerEvents = 'none';
    console.log('[outdoer] search replaced with anchor');
  }

  function placeElements() {
    if (!isMobile()) return;

    // Pin hamburger drawer to leftA
    var drawer = document.querySelector('.header__drawer');
    if (drawer) {
      drawer.style.setProperty('grid-area', 'leftA', 'important');
      drawer.setAttribute('data-outdoer-placed', 'leftA');
    }

    // CRITICAL: constrain the inner elements so the visible icon stays
    // inside the 44px wrapper instead of stretching 400px wide and
    // centering the icon at x=240 (which looks like "next to the logo").
    var innerSelectors = [
      '.header__drawer header-drawer',
      '.header__drawer details.menu-drawer-container',
      '.header__drawer summary.header__icon--menu',
      '.header__drawer summary.header__icon--summary',
    ];
    innerSelectors.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      el.style.setProperty('width', '44px', 'important');
      el.style.setProperty('max-width', '44px', 'important');
      el.style.setProperty('flex', '0 0 44px', 'important');
      el.style.setProperty('justify-content', 'flex-start', 'important');
      el.style.setProperty('padding-inline', '0', 'important');
      el.style.setProperty('padding-left', '0', 'important');
      el.style.setProperty('padding-right', '0', 'important');
    });

    // Pin search to rightA. Push it leftward inside its cell so it
    // doesn't kiss the cart in rightB.
    var search = document.querySelector('.search-action');
    if (search) {
      search.style.setProperty('grid-area', 'rightA', 'important');
      search.style.setProperty('margin-inline-end', '24px', 'important');
      search.style.setProperty('margin-right', '24px', 'important');
      search.style.setProperty('justify-self', 'start', 'important');
      search.setAttribute('data-outdoer-placed', 'rightA');
    }
    // Also target the inner <search-button> in case .search-action is a wrapper
    var searchBtn = document.querySelector('search-button, .search-action button, button.search-action__button');
    if (searchBtn) {
      searchBtn.style.setProperty('margin-inline-end', '16px', 'important');
    }

    // Lock logo to center (sometimes auto-flow displaces it)
    var logo = document.querySelector('.header-logo');
    if (logo) {
      logo.style.setProperty('grid-area', 'center', 'important');
    }

    // Lock header-actions (cart) to rightB AND constrain its width
    // so its inner cart-drawer-component / account-drawer don't blow the
    // box out to 400px+ and bleed off-screen.
    var actions = document.querySelector('header-actions');
    if (actions) {
      actions.style.setProperty('grid-area', 'rightB', 'important');
      actions.style.setProperty('width', 'auto', 'important');
      actions.style.setProperty('min-width', '0', 'important');
      actions.style.setProperty('max-width', '120px', 'important');
      actions.style.setProperty('margin-inline-start', '0', 'important');
      actions.style.setProperty('justify-content', 'flex-end', 'important');
      actions.style.setProperty('justify-self', 'end', 'important');
      actions.style.setProperty('padding-inline-end', '8px', 'important');
      actions.style.setProperty('gap', '12px', 'important');
    }

    // Constrain cart-drawer-component to 44px (the trigger button size).
    // The slide-out dialog inside is position:fixed and doesn't need width.
    // Add left margin so it doesn't kiss the search icon.
    var cartCmp = document.querySelector('cart-drawer-component');
    if (cartCmp) {
      cartCmp.style.setProperty('width', '44px', 'important');
      cartCmp.style.setProperty('max-width', '44px', 'important');
      cartCmp.style.setProperty('display', 'inline-flex', 'important');
      cartCmp.style.setProperty('align-items', 'center', 'important');
      cartCmp.style.setProperty('justify-content', 'center', 'important');
      cartCmp.style.setProperty('flex', '0 0 44px', 'important');
      cartCmp.style.setProperty('margin-inline-start', '16px', 'important');
      cartCmp.style.setProperty('margin-left', '16px', 'important');
    }

    // Account drawer dialog-component — constrain to 36px (just the icon).
    var accountDrawer = document.querySelector('header-actions dialog-component.account-drawer');
    if (accountDrawer) {
      accountDrawer.style.setProperty('width', '36px', 'important');
      accountDrawer.style.setProperty('max-width', '36px', 'important');
      accountDrawer.style.setProperty('flex', '0 0 36px', 'important');
      accountDrawer.style.setProperty('display', 'inline-flex', 'important');
      accountDrawer.style.setProperty('align-items', 'center', 'important');
      accountDrawer.style.setProperty('justify-content', 'center', 'important');
    }
  }

  // Track recently-viewed product handles in localStorage so the
  // You-May-Also-Like section can retarget the visitor with stuff
  // they've browsed but haven't bought.
  function trackRecentlyViewed() {
    try {
      var path = window.location.pathname;
      if (path.indexOf('/products/') !== 0) return;
      var handle = path.replace('/products/', '').split('?')[0].split('/')[0];
      if (!handle) return;
      var KEY = 'outdoer.recently_viewed';
      var MAX = 12;
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > MAX) list = list.slice(0, MAX);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) { /* localStorage may be disabled — silently bail */ }
  }

  // Active filter chips above the collection grid. Reads URL params,
  // renders removable chips, "Clear all" link. Compounds with Shopify's
  // Search & Discovery filter config.
  function renderFilterChips() {
    if (!/^\/collections\//.test(location.pathname)) return;
    var grid = document.querySelector('.product-grid, .collection-grid, [data-product-grid], main-collection, .main-collection');
    if (!grid) return;

    var params = new URLSearchParams(location.search);
    var chips = [];
    params.forEach(function (val, key) {
      if (key.indexOf('filter.') !== 0) return;
      // key examples:
      //   filter.p.tag, filter.v.option.color, filter.v.option.size,
      //   filter.v.price.gte, filter.v.price.lte, filter.p.vendor
      var label = key.replace('filter.p.tag', 'Tag')
        .replace('filter.p.vendor', 'Brand')
        .replace('filter.v.option.', '')
        .replace('filter.v.price.gte', 'Min price')
        .replace('filter.v.price.lte', 'Max price')
        .replace(/^./, function (c) { return c.toUpperCase(); });
      // Strip tag namespace like "scene:the-hamptons" → "the-hamptons"
      var display = String(val).replace(/^(scene|activity|color|size):/i, '').replace(/-/g, ' ');
      display = display.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      chips.push({ key: key, val: val, display: display, label: label });
    });

    var bar = document.getElementById('outdoer-filter-chips');
    if (chips.length === 0) {
      if (bar) bar.remove();
      return;
    }
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'outdoer-filter-chips';
      bar.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;align-items:center;padding:14px clamp(16px,3vw,32px);font-family:var(--outdoer-font-sans,Inter),sans-serif;font-size:12px;letter-spacing:0.05em;';
      grid.parentNode.insertBefore(bar, grid);
    }
    var clearUrl = location.pathname;
    bar.innerHTML = chips.map(function (c) {
      var newParams = new URLSearchParams(location.search);
      newParams.delete(c.key);
      var href = location.pathname + (newParams.toString() ? '?' + newParams.toString() : '');
      return '<a href="' + href + '" style="display:inline-flex;align-items:center;gap:6px;padding:6px 12px;background:rgba(60,53,43,0.08);color:inherit;text-decoration:none;border-radius:999px;transition:background 0.2s;">' +
        '<span>' + c.display + '</span>' +
        '<span aria-hidden="true" style="font-size:14px;line-height:1;opacity:0.7;">&times;</span>' +
        '</a>';
    }).join('') +
      '<a href="' + clearUrl + '" style="margin-left:8px;text-decoration:underline;color:inherit;opacity:0.7;font-size:11px;text-transform:uppercase;letter-spacing:0.18em;">Clear all</a>';
  }

  // Run early and often — covers DOMContentLoaded, late-loading content,
  // theme editor live re-renders, and resize crossings.
  function runAll() {
    placeElements();
    wireSearchButton();
    trackRecentlyViewed();
    renderFilterChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll, { once: true });
  } else {
    runAll();
  }

  // Retry several times to beat any late mutation by Horizon's JS
  var attempts = 0;
  var tick = setInterval(function () {
    runAll();
    attempts += 1;
    if (attempts >= 10) clearInterval(tick);
  }, 200);

  // On resize crossing the breakpoint, re-run / clear inline style
  var lastMobile = isMobile();
  window.addEventListener('resize', function () {
    var nowMobile = isMobile();
    if (nowMobile !== lastMobile) {
      lastMobile = nowMobile;
      if (nowMobile) {
        runAll();
      } else {
        // On desktop, clear inline styles so Horizon's desktop CSS wins
        ['.header__drawer', '.search-action', '.header-logo', 'header-actions'].forEach(function (sel) {
          var el = document.querySelector(sel);
          if (el) el.style.removeProperty('grid-area');
        });
      }
    }
  });
})();
